import { useEffect } from "react";

interface CalendarModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CalendarModal({ isOpen, onClose }: CalendarModalProps) {
  // Load the booking widget script
  useEffect(() => {
    const src = "https://links.dino-nuggets.com/js/form_embed.js";
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) return;
    const script = document.createElement("script");
    script.src = src;
    script.type = "text/javascript";
    document.body.appendChild(script);
  }, []);

  // Lock body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Close on Escape key
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-y-auto"
      role="dialog"
      aria-modal="true"
      aria-label="Book a call"
    >
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal panel */}
      <div className="relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-2xl my-8 flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 sticky top-0 bg-white rounded-t-2xl z-10">
          <div>
            <h2 className="font-display text-xl font-bold text-secondary">
              Book Your Free Discovery Call
            </h2>
            <p className="text-sm text-gray-500 mt-0.5">
              Pick a time that works best for you
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
            aria-label="Close"
          >
            <i className="ri-close-line text-xl text-gray-500"></i>
          </button>
        </div>

        {/* Calendar iframe */}
        <div className="p-4">
          <iframe
            src="https://links.dino-nuggets.com/widget/booking/jYUOBrtBoczrAEOTlhKv"
            style={{ width: "100%", border: "none" }}
            scrolling="yes"
            id="jYUOBrtBoczrAEOTlhKv_1772734614613"
            title="Book a Discovery Call"
            className="min-h-[800px] rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}
